function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><title>more-down-arrow</title><path d="M12.994 7.357a.91.91 0 1 1 1.285 1.286l-3.636 3.636a.91.91 0 0 1-1.286 0L5.721 8.643a.91.91 0 1 1 1.285-1.286L10 10.351l2.994-2.994z" fillRule="nonzero" fill="#42444C" /></svg>;
});